import React, { useState, useRef } from 'react';
import { Search } from 'lucide-react';
import { IDX_SEARCH_URL } from '../../constants/site';
import { flattenNavItems } from '../../constants/nav';
import { useClickOutside } from '../../hooks/useClickOutside';
import { QuickSearchForm, QuickSearchItem, QuickSearchCallBar } from './QuickSearchParts';

export const QuickSearchDropdown = ({ navItems }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const ref = useRef(null);
  useClickOutside(ref, () => setOpen(false));

  const close = () => setOpen(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const target = query.trim() ? `${IDX_SEARCH_URL}#${encodeURIComponent(query)}` : IDX_SEARCH_URL;
    window.open(target, '_blank');
    close();
    setQuery('');
  };

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="quick-search-toggle"
        onClick={() => setOpen(!open)}
        aria-label="Open Quick Search"
        className="flex items-center justify-center space-x-2 bg-gradient-to-r from-gold-400 to-gold-500 hover:from-gold-500 hover:to-gold-600 text-[#143160] font-bold px-4 sm:px-5 min-h-[44px] rounded-full shadow-lg transition-all hover:scale-105"
      >
        <Search className="w-5 h-5" />
        <span className="hidden sm:inline whitespace-nowrap">Quick Search</span>
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-3 w-80 bg-sand-50 rounded-2xl shadow-2xl border border-gray-100 overflow-hidden z-50">
          <QuickSearchForm query={query} setQuery={setQuery} onSubmit={handleSubmit} />
          <div className="py-2 border-t border-gray-100 max-h-[55vh] overflow-y-auto">
            {flattenNavItems(navItems).map((item) => <QuickSearchItem key={item.label} item={item} onNavigate={close} />)}
          </div>
          <QuickSearchCallBar />
        </div>
      )}
    </div>
  );
};
